import type { ActivationRouter } from "replo-publisher/src/trpc/routers/activation";

import { getNamespacedQueryClient } from "@v2/trpc/trpc";

import { createTrpcRouterConfig } from "../config";

const {
  router: activationRouter,
  client: activationClient,
  utils: activationUtils,
  options: activationOptions,
} = createTrpcRouterConfig<ActivationRouter>({
  path: "activation",
  queryClient: getNamespacedQueryClient("activation"),
});

export {
  activationClient,
  activationRouter,
  activationUtils,
  activationOptions,
};
